<div class="main-container" style="    margin-top: 0%;">
  <div class="label-bar">
     <label i18n="@@spmsUserReg" class="textColour" style="font-size: 18px;
    font-weight: 500;">Role Product Group Mapping</label>
     <span class="example-spacer"></span>
       <!-- <app-common-button 
          title="Refresh"
          icon="fas fa-sync-alt"
          [buttonId]="1111"
          [variant]="'cancel'"
          width="100%"
          padding="0rem 1rem"
          fontSize=".85rem"
          height="25px"
          (clicked)="onRefresh()"
          style="margin-right:1%"
          >
      </app-common-button> -->
        <app-common-button
          label="Map Selected"
          title="Map Selected"
          [buttonId]="114"
          width="150px"
          [critical]="true"
          (clicked)="onMapProductGroupClick()"
           style="margin-left: 6px;margin-right:6px;"
          >
 
          </app-common-button>
       <app-common-button
          label="Create Product Group"
          title="Create Product Group "
          [buttonId]="114"
          width="150px"
          [critical]="true"
          (clicked)="onCreateProductGroup()"
           style="margin-left: 6px;margin-right:6px;"
          >
 
          </app-common-button>
  </div>

  <div class="mapping-container">
  <div class="left-panel">
    <div class="panel-header">
      <h3>Roles</h3>
    </div>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Search Role</mat-label>
      <input
        matInput
        [(ngModel)]="roleSearchText"
        (input)="filterRoles()"
        placeholder="Search role..."
      />
    </mat-form-field>

    <div class="group-list">
      <div
        *ngFor="let role of filteredRoles"
        class="group-item"
        [class.selected]="selectedRole?.userrolesmstrid === role.userrolesmstrid"
        (click)="onRoleSelect(role)"
      >
        <div class="group-name">{{ role.rolename }}</div>
      </div>
    </div>
  </div>

  <div class="right-panel">
    <div class="right-header">
      <div>
         <div class="role-name-row">
        <h3 style="color:red;">{{ selectedRole?.rolename || 'Product Groups' }}</h3>
        <span class="count-pill"
                >{{selectedProductGroup.length }} Product Groups</span
              >
              </div>
        <p class="sub-text" *ngIf="selectedRole">
          Manage product groups mapped to this role
        </p>
      </div>

      <div class="header-actions">
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Filter</mat-label>
          <mat-select [(ngModel)]="mappingFilter" (selectionChange)="applyProductGroupFilter()">
            <mat-option value="ALL">All</mat-option>
            <mat-option value="MAPPED">Mapped</mat-option>
            <mat-option value="UNMAPPED">Unmapped</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="search-field">
          <mat-label>Search Product Group</mat-label>
          <input
            matInput
            [(ngModel)]="productGroupSearchText"
            (input)="applyProductGroupFilter()"
            placeholder="Search product group..."
          />
        </mat-form-field>
      </div>
    </div>

  <ag-grid-angular
      style="margin-top: -1%;height: 45vh;"
      class="ag-theme-balham"
      [rowData]="filteredRowData"
      [components]="components"
      [columnDefs]="columnDefs"
      [defaultColDef]="defaultColDef"
      [rowSelection]="'multiple'"
       [rowMultiSelectWithClick]="true"
      [suppressRowClickSelection]="true"
      [animateRows]="true"
      [paginationPageSize]="50"
      (gridReady)="onGridReady($event)"
      (selectionChanged)="onSelectionChanged($event)"
      [rowHeight]="35"
      [headerHeight]="35"
      [enableBrowserTooltips]="true"
      [floatingFiltersHeight]="45"
      [pagination]="true"
       [suppressPaginationPanel]="true">
    </ag-grid-angular>
    <div class="custom-pagination">
  <span class="range-text">
    {{ startRow }} to {{ endRow }} of {{ totalRows }}
  </span>

  <!-- <button (click)="goToFirst()" [disabled]="currentPage === 1">
     
  </button> -->
  <em class="fas fa-angle-double-left waves-effect waves-light" (click)="goToFirst()"></em>
  <em class="fas fa-angle-left waves-effect waves-light"
                                    (click)="goToPrevious()"></em>
  <!-- <button (click)="goToPrevious()" [disabled]="currentPage === 1">‹</button> -->

  <span class="page-text">
    Page {{ currentPage }} of {{ totalPages }}
  </span>
<em class="fas fa-angle-right waves-effect waves-light" (click)="goToNext()"></em>
<em class="fas fa-angle-double-right waves-effect waves-light" (click)="goToLast()"></em>
  <!-- <button (click)="goToNext()" [disabled]="currentPage === totalPages">›</button>
  <button (click)="goToLast()" [disabled]="currentPage === totalPages">»</button> -->
</div>
  </div>
</div>
  </div>